<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M900 1110 c-11 -11 -20 -32 -20 -47 l0 -27 -16 22 c-18 27 -55 29
-77 4 -15 -16 -17 -47 -17 -225 0 -114 -2 -207 -5 -207 -3 0 -34 18 -69 40
-35 22 -71 40 -80 40 -21 0 -56 -35 -56 -57 0 -9 39 -56 88 -103 48 -48 102
-105 119 -127 19 -23 47 -44 65 -49 38 -11 52 -44 18 -44 -20 0 -21 -4 -18
-87 l3 -88 210 0 210 0 3 88 3 87 -42 0 -41 0 7 58 c4 31 9 181 11 333 4 245
3 279 -11 293 -19 19 -56 21 -73 4 -8 -8 -12 -52 -12 -130 0 -77 -4 -118 -11
-118 -7 0 -10 45 -8 139 3 149 -3 171 -45 171 -12 0 -27 -5 -34 -12 -9 -9 -12
-8 -12 5 0 21 -35 57 -55 57 -8 0 -24 -9 -35 -20z m68 -173 c2 -153 4 -168 20
-165 15 3 17 20 20 145 2 118 5 142 19 147 36 14 43 -10 43 -165 0 -142 1
-149 20 -149 18 0 20 8 22 128 3 124 4 127 26 130 51 7 52 0 52 -282 0 -332 7
-314 -150 -355 l-35 -9 38 -1 c21 -1 54 6 74 14 48 20 50 20 45 -15 l-4 -30
-133 0 c-128 0 -134 1 -137 21 -2 14 -16 25 -43 35 -22 7 -51 28 -65 45 -14
18 -65 72 -114 120 -77 77 -88 91 -82 113 9 38 40 33 123 -18 39 -25 74 -42
77 -39 3 4 6 36 6 73 l0 67 29 -5 c19 -2 39 3 55 14 25 19 25 20 26 175 0 163
5 183 45 177 19 -3 20 -11 23 -171z m-111 13 c2 -76 0 -100 -8 -87 -14 24 -26
21 -43 -10 -14 -26 -15 -21 -16 83 0 61 3 114 7 118 4 4 19 6 33 4 25 -3 25
-4 27 -108z m-9 -115 c7 -14 12 -37 12 -50 0 -21 -5 -25 -30 -25 -25 0 -30 4
-30 25 0 27 19 75 30 75 4 0 12 -11 18 -25z m392 -590 l0 -75 -195 0 -195 0 0
75 0 75 195 0 195 0 0 -75z"
      />
      <path
        d="M915 690 c-4 -6 27 -10 84 -10 54 0 91 4 91 10 0 6 -35 10 -84 10
-47 0 -88 -4 -91 -10z"
      />
      <path
        d="M880 604 c0 -4 15 -20 33 -35 30 -26 32 -30 31 -93 -1 -42 3 -63 9
-57 18 18 13 108 -8 137 -22 29 -65 61 -65 48z"
      />
      <path
        d="M1137 282 c-22 -24 -21 -55 1 -75 37 -33 92 -11 92 37 0 48 -62 73
-93 38z m73 -21 c20 -38 -13 -71 -51 -51 -18 10 -26 50 -12 63 13 14 53 6 63
-12z"
      />
      <path
        d="M181 1058 c-85 -42 -139 -117 -156 -216 l-7 -42 98 0 98 0 63 -62 63
-62 0 102 c0 56 2 102 4 102 3 0 30 -27 62 -60 l57 -60 69 0 c39 0 68 -4 68
-10 0 -6 -29 -10 -67 -10 l-67 0 -53 52 -53 52 0 -97 c0 -53 -4 -97 -8 -97 -4
0 -37 29 -72 65 l-64 65 -97 0 -97 0 10 -42 c5 -24 17 -55 27 -70 9 -15 126
-137 258 -271 l242 -243 111 111 c61 61 107 114 103 118 -4 4 -53 -39 -110
-95 l-103 -103 -226 225 c-227 226 -284 294 -284 338 0 23 1 24 76 19 l76 -4
82 -82 c45 -44 85 -81 89 -81 4 0 7 45 7 100 l0 100 37 -40 36 -41 81 3 c80 3
81 3 84 31 l3 27 -73 0 -73 0 -77 77 -78 78 0 -105 0 -104 -48 47 -48 47 -92
0 -92 0 6 28 c20 81 71 150 138 184 22 11 69 23 103 26 86 7 134 -14 207 -87
l59 -60 65 59 c35 33 80 64 100 71 42 13 59 25 49 35 -14 14 -100 -30 -152
-78 l-55 -50 -50 45 c-73 66 -125 87 -212 87 -55 0 -84 -5 -117 -22z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
